import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { QuestionType } from '@module/form';
import { BaseQuestionSwitchStrategy } from './base.strategy';
/**
 * Strategy: Fill in Blank → Other Types
 * Rule 6: Fill in Blank → Any resets description & answers
 */

export var FillInBlankSwitchStrategy = /*#__PURE__*/function (_BaseQuestionSwitchSt) {
  _inherits(FillInBlankSwitchStrategy, _BaseQuestionSwitchSt);

  var _super = _createSuper(FillInBlankSwitchStrategy);

  function FillInBlankSwitchStrategy() {
    _classCallCheck(this, FillInBlankSwitchStrategy);

    return _super.call(this, QuestionType.FillInBlank);
  }

  _createClass(FillInBlankSwitchStrategy, [{
    key: "canHandle",
    value: function canHandle(toType) {
      return this.fromType === QuestionType.FillInBlank;
    }
  }, {
    key: "execute",
    value: function execute(toType) {
      switch (toType) {
        case QuestionType.SingleChoice:
        case QuestionType.MultipleChoice:
          // Rule 6: Fill in Blank → Choice types resets description & answers
          return {
            shouldPreserveAnswers: false,
            shouldPreserveDescription: false,
            // Reset description too!
            shouldResetToDefault: true,
            shouldClearAnswers: true,
            strategyName: "FillInBlank \u2192 ".concat(toType, ": Reset all (description + answers)")
          };

        case QuestionType.Essay:
          // Rule 5: Any → Essay clears all answers
          return {
            shouldPreserveAnswers: false,
            shouldPreserveDescription: true,
            shouldResetToDefault: false,
            shouldClearAnswers: true,
            strategyName: 'FillInBlank → Essay: Clear answers'
          };

        case QuestionType.Matching:
          // Rule 7: Fill in Blank → Matching resets to different complex type
          return {
            shouldPreserveAnswers: false,
            shouldPreserveDescription: true,
            shouldResetToDefault: true,
            shouldClearAnswers: true,
            strategyName: 'FillInBlank → Matching: Reset to complex type'
          };

        default:
          return this.getDefaultResult(toType);
      }
    }
  }, {
    key: "getDefaultResult",
    value: function getDefaultResult(toType) {
      return {
        shouldPreserveAnswers: false,
        shouldPreserveDescription: false,
        shouldResetToDefault: true,
        shouldClearAnswers: true,
        strategyName: "FillInBlank \u2192 ".concat(toType, ": Default behavior")
      };
    }
  }]);

  return FillInBlankSwitchStrategy;
}(BaseQuestionSwitchStrategy);